export const BG = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11400)">
      <g clipPath="url(#clip1_1073_11400)">
      <rect y="64" width="96" height="32" fill="#EF4444"/>
      <rect y="32" width="96" height="32" fill="#00C17B"/>
      <rect width="96" height="32" fill="white"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11400">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11400">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
